import React from "react";
import { colors } from "../../constants/colors";
import cartoonTeam from "../../images/cartoonTeam.svg";
export const TeamStory = () => {
  return (
    <section
      className="team-story container-fluid text-center"
      id="team-story"
      // data-aos="zoom-in-left"
      style={{ backgroundColor: colors.gencWhite }}
    >
      <h1 style={{ color: colors.gencBlue }}>Our Story</h1>
      <p
        style={{ color: colors.gencBlack }}
        data-aos="fade-up"
        data-aos-delay="250"
      >
        When it comes to our private information regarding our identities and our lives, we make sure to keep this information as safe and secure as possible. But how can we be sure that our information is still private when it seems that even the most secure companies are susceptible to being hacked? Some choose to keep their information on paper stored in a cupboard somewhere in their home while others may keep it on a local hard drive, but there are so many problems with this. What if your house burns down? What if you’re abroad and don’t have access to your files? In this day and age, we would not continue to use a typewriter to write up a letter when we can use a keyboard, so why do we continue to store our data with out-dated methods? This is the dilemma that GenC Labs has identified and seeks to change using the latest technology that will revolutionize how we choose to store our data. 


      </p>
      <img className="p-5" src={cartoonTeam} alt="Cartoon Team" />
      <p
        style={{ color: colors.gencBlack }}
        data-aos="fade-up"
        data-aos-delay="500"
      >
        These are dark times in our history with data security breaches all over the world and the global Coronavirus pandemic wreaking havoc on our livelihoods. These events have had such an impact in history that the generations born after 2019 will often be referred to as Generation C. Therefore, the Angelo Network research team has decided to emerge out of the research lab and use GenC and GenC Health as brands to leverage the hybrid-blockchain and the new data store protocol for the benefits of generations to come.
      </p>
    </section>
  );
};
